import { allSections } from 'components/sections';
import { FIXED_TOP, FIXED_BOTTOM, PREHEADER, HEADER, BODY } from 'utils/sectionTypes';

export function getSectionRegion(type) {
  // We do not want deleted sections to whitescreen the app, and we want
  // them to grab attention in the builder, so we fall back to FIXED_TOP
  if (!allSections[type]) {
    return FIXED_TOP;
  }

  return allSections[type].details.region;
}

const testSection = (type, isFixed) => {
  const region = getSectionRegion(type);
  if (isFixed) {
    return region === FIXED_BOTTOM || region === FIXED_TOP;
  }
  return region !== FIXED_BOTTOM && region !== FIXED_TOP;
};

export function mergeSections(sections, layoutSections) {
  // For now, we're going to work under the assumption that a page cannot have a section in a region
  // if the layout it inherits from also uses that region (ignoring BODY, of course)
  const layoutRegions = layoutSections.reduce((regions, { type }) => {
    const region = getSectionRegion(type);
    if (!regions.includes(region) && region !== BODY) {
      regions.push(region);
    }

    return regions;
  }, []);

  // If the layout has a header, this layout might as well have a pre-header
  if (layoutRegions.includes(HEADER)) {
    layoutRegions.push(PREHEADER);
  }

  const fixedSections = sections.filter(({ type }) => testSection(type, true));
  const inlineSections = sections.filter(({ type }) => testSection(type, false));

  return layoutSections.reduce((finalSections, layoutSection) => {
    // Replace the ChildBlock section with the actual sections of this version
    if (layoutSection.type === 'ChildBlock') {
      return [
        ...finalSections,
        ...inlineSections.filter(({ type }) => !layoutRegions.includes(getSectionRegion(type))),
      ];
    }

    return [
      ...finalSections,
      { ...layoutSection, isLayout: true },
    ];
  }, [
    ...fixedSections,
  ]);
}
